<template>
    <div class="qzsy-container">
        <h3 class="card-title">七政四余排盘</h3>
        <!-- 头部信息卡片 -->
        <div class="header-card glow-card" v-if="data?.headers">
            <div class="header-row">
                <span class="header-label">出生时间：</span>
                <span>{{ data.headers.birth }}</span>
            </div>
            <div class="header-row">
                <span class="header-label">推运至：</span>
                <span>{{ data.headers.now }}</span>
            </div>
            <div class="header-row">
                <span class="header-label">年龄：</span>
                <span>{{ data.headers.age }}</span>
            </div>
            <div class="header-row">
                <span class="header-label">经纬度：</span>
                <span>{{ data.headers.location }}</span>
            </div>
            <div class="header-row">
                <span class="header-label">干支：</span>
                <span>{{ data.headers.poles }}</span>
            </div>
            <div class="header-row">
                <span class="header-label">日出日落：</span>
                <span>{{ data.headers.sun }}</span>
            </div>
            <div class="header-row">
                <span class="header-label">月出月落：</span>
                <span>{{ data.headers.moon }}</span>
            </div>
            <div class="header-row">
                <span class="header-label">政余今制：</span>
                <span>{{ data.headers.xingZhi }}</span>
            </div>
        </div>

        <!-- Tab切换 -->
        <a-tabs v-model:activeKey="activeTab" class="qzsy-tabs">
            <a-tab-pane key="benMing" tab="本命">
                <BenMingTable :data="data?.benMing" />
            </a-tab-pane>
            <a-tab-pane key="benSha" tab="本煞">
                <BenShaTable :data="data?.benSha" />
            </a-tab-pane>
            <a-tab-pane key="liuNian" tab="流年">
                <LiuNianTable :data="data?.liuNian" />
            </a-tab-pane>
            <a-tab-pane key="liuSha" tab="流煞">
                <LiuShaTable :data="data?.liuSha" />
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script setup>
import axios from '@/utils/axios';
import dayjs from 'dayjs';
import { defineProps, onMounted, ref, watch } from 'vue';
import BenMingTable from './BenMingTable.vue';
import BenShaTable from './BenShaTable.vue';
import LiuNianTable from './LiuNianTable.vue';
import LiuShaTable from './LiuShaTable.vue';

const props = defineProps({
    birthDateTime: {
        type: Object,
        required: true
    },
    gender: {
        type: Number,
        required: true
    },
    longitude: {
        type: Number,
        default: 116.4
    },
    latitude: {
        type: Number,
        default: 39.9
    },
    timezone: {
        type: String,
        default: 'Asia/Shanghai'
    }
})

const data = ref(null)
const loading = ref(false)
const activeTab = ref('benMing')

// 监听参数变化重新获取数据
watch(
    () => [props.birthDateTime, props.longitude, props.latitude, props.timezone],
    () => {
        fetchData()
    },
    { deep: true }
)

const fetchData = async () => {
    loading.value = true
    try {
        const res = await axios.get('/api/rili/v3/bazi/moira/qzsy', {
            params: {
                birth: `${props.birthDateTime.year()},${props.birthDateTime.month() + 1},${props.birthDateTime.date()},${props.birthDateTime.hour()},${props.birthDateTime.minute()},0`,
                now: `${dayjs().year()},${dayjs().month() + 1},${dayjs().date()},${dayjs().hour()},${dayjs().minute()},0`,
                xingZhi: 0,
                zone: props.timezone,
                lat: props.latitude,
                lng: props.longitude
            }
        })
        data.value = res.data.data.data
    } catch (e) {
        console.error('获取七政四余数据失败:', e)
    } finally {
        loading.value = false
    }
}

onMounted(() => {
    fetchData()
})
</script>

<style scoped>
.qzsy-container {
    margin-top: 20px;
}

/* 头部信息卡片 */
.header-card {
    background: rgba(30, 30, 40, 0.8);
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid rgba(110, 90, 210, 0.3);
    box-shadow: 0 0 15px rgba(110, 90, 210, 0.2);
}

.header-row {
    display: flex;
    margin-bottom: 8px;
    line-height: 1.6;
}

.header-label {
    min-width: 100px;
    font-weight: bold;
    color: #9370db;
}

/* Tab样式 */
.qzsy-tabs :deep(.ant-tabs-nav) {
    margin: 0;
}

.qzsy-tabs :deep(.ant-tabs-tab) {
    color: #b0b0b0;
    font-weight: bold;
}

.qzsy-tabs :deep(.ant-tabs-tab-active) {
    color: #9370db !important;
}

.qzsy-tabs :deep(.ant-tabs-ink-bar) {
    background: #9370db;
}

.qzsy-tabs :deep(.ant-tabs-content) {
    padding: 16px 0;
}
</style>